import React, { ReactElement } from 'react';
import { Box, makeStyles } from 'housecall-ui';
import { HCPTheme } from 'housecall-ui/dist/Theme/Theme';

import { useOnlineBookingReducer } from '../state/useOnlineBookingReducer';

import { PoweredBy } from './PoweredBy';

type StyleProps = {
  cartVisible: boolean;
};

const useStyles = makeStyles((theme: HCPTheme) => ({
  actionButtonsWrapper: {
    backgroundColor: theme.palette.background.main,
    display: 'flex',
    gap: `14px`,
    position: 'absolute',
    bottom: '0',
    left: '0',
    width: '100%',
    zIndex: theme.zIndex.snackbar,
    padding: `${theme.spacing(2)}px ${theme.spacing(3)}px`,
    boxShadow: theme.shadows[4],
    flexDirection: 'column',
  },
  actionButtons: {
    display: 'flex',
    gap: `${theme.spacing(2)}px`,
    width: '100%',
  },
  stepWrapper: {
    minHeight: '0',
    display: 'flex',
    flexDirection: 'column',
    marginTop: ({ cartVisible }: StyleProps) => theme.spacing(cartVisible ? 3 : 2),
  },
}));

type Props = {
  ContentComponent: ReactElement<unknown, string>;
  Buttons?: ReactElement<unknown, string>;
  Header?: ReactElement<unknown, string>;
};

export const Layout = (props: Props) => {
  const { ContentComponent, Header, Buttons } = props;

  const { state } = useOnlineBookingReducer();
  const { cart } = state;

  const { actionButtons, stepWrapper, actionButtonsWrapper } = useStyles({
    cartVisible: cart.length > 0,
  });
  return (
    <>
      {Header}
      <div className={stepWrapper}>{ContentComponent}</div>
      <Box className={actionButtonsWrapper}>
        <Box className={actionButtons}>{Buttons}</Box>
        <PoweredBy />
      </Box>
    </>
  );
};
